import { render, staticRenderFns } from "./BackContainer.vue?vue&type=template&id=af8de710&scoped=true"
import script from "./BackContainer.vue?vue&type=script&lang=js"
export * from "./BackContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af8de710",
  null
  
)

export default component.exports